import { gql } from "@apollo/client";

export default gql`
  mutation addBotToMeetingNewPageMutation($meetingId: Int!) {
    addBotToMeeting(meetingId: $meetingId) {
      meeting {
        botIsRecording
        botIsWaitingToJoinMeeting
        hasBotInMeeting
        id
      }
    }
  }
`;
